import { extendZodWithOpenApi } from "@asteasolutions/zod-to-openapi";
import { z } from "zod";

extendZodWithOpenApi(z);

/**
 * Zod schema for phone numbers in E.164 wire format: a leading `+`, then up to 15 digits.
 */
export const E164PhoneNumber = z
    .string()
    .regex(/^\+[1-9]\d{1,14}$/, "must be an E.164 phone number, e.g. +14155550100")
    .openapi({
        type: "string",
        description: "Phone number in E.164 format",
        example: "+14155550100",
    });
